module.exports = __webpack_public_path__ + "static/img/case-glj-page-bg-07.4185df2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/glj/case-glj-page-bg-07.jpg
// module id = oiid
// module chunks = 1